module.exports = __webpack_public_path__ + "img/monitorbox02.dd440a98.jpg";